module.exports = __webpack_public_path__ + "static/media/googleshare.406d3709.svg";